<script>
import Alert from '../Components/Alert.vue';

export default {
  components: {
    Alert,
  },

  props: {
    id: String,
    pk: String,
    message: String,
    icon: {
      type: String,
      default: 'fa fa-comment-alt',
    },
    dismissable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['dismissed'],

  data() {
    return {
      masterConfig: this.$page.props.master_config,
      processedMessage: '',
    };
  },

  computed: {
    clearedID() {
      return this.id.replace('ID|', '');
    },
  },

  mounted() {
    this.htmlMessage();
  },

  methods: {
    htmlMessage() {
      if (this.message.length > 0) {
        axios
          .post(route('messages.preview', { shop_id: this.masterConfig.shop_id }), {
            message: this.message,
          })
          .then((response) => {
            this.processedMessage = response.data.data.processed;
          });
      }
      return this.message;
    },
  },
};
</script>

<template>
  <Alert
    v-if="processedMessage !== null && processedMessage.length > 0"
    class="success"
    :dismissible="dismissable"
    @dismissed="$emit('dismissed', clearedID, pk)"
  >
    <i :class="icon" /> |
    <span v-html="processedMessage" />
  </Alert>
</template>
